import _ from 'lodash'

function handleOauthTokenEndpointException(xhr) {
	const responseJSON = xhr.responseJSON
	if (!_.isNil(responseJSON?.oauthTokenEndpointResponseBody)) {
		const errorMessage = responseJSON?.resolvable?.message
		const errorDetails = JSON.stringify(responseJSON?.oauthTokenEndpointResponseBody, null, '\t')
		this.formView.clearErrors()
		this.formView.responseJSON = null
		this.formView.errorMessage(errorMessage, errorDetails)
		return
	}

	this.formView.error(xhr)
}

export default handleOauthTokenEndpointException
handleOauthTokenEndpointException.__filename__ = 'admin/connections/rest/handle-oauth-token-endpoint-exception.js'
